import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import ExamLevelAPIs from '../../db/exam-level';
import { mapExamLevelToNode, mapPaginatedExamLevels } from './utils';
export const epExamLevelQueries = {
    async ep_examLevelList(_, { communityID, pagination }, context) {
        const result = await ExamLevelAPIs.getList(getCurrentUserID(), communityID, pagination);
        return mapPaginatedExamLevels(result);
    },
    async ep_examLevelDetails(_, { examLevelID }, context) {
        const result = await ExamLevelAPIs.getByID(getCurrentUserID(), examLevelID);
        return mapExamLevelToNode(result);
    },
};
